/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ShowWeatherDataResponse,
} from '../models/index';
import {
    ShowWeatherDataResponseFromJSON,
    ShowWeatherDataResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class ExternalApi extends runtime.BaseAPI {

    /**
     * Show weather data for the current company (based on the lat/lng of the company).
     * Show Weather Data
     */
    async showWeatherDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowWeatherDataResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/external/weather`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowWeatherDataResponseFromJSON(jsonValue));
    }

    /**
     * Show weather data for the current company (based on the lat/lng of the company).
     * Show Weather Data
     */
    async showWeatherData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowWeatherDataResponse> {
        const response = await this.showWeatherDataRaw(initOverrides);
        return await response.value();
    }

}
